module.exports = __webpack_public_path__ + "img/sudan.25d5ef6c.png";